// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"MFh2F","hidden":"_3Abwf","buttonWrapper":"_1zu08","downloadButton":"_1DUyz","icon_small":"_2N2nU","iconSmall":"_2N2nU","icon_big":"_1pfJh","iconBig":"_1pfJh"};